import HeroModule from '$lib/storyblok/blocks/heroModule.svelte';
import HeroModuleV2 from '$lib/storyblok/blocks/heroModuleV2.svelte';
import HeroModuleNyc from '$lib/storyblok/blocks/heroModuleNyc.svelte';
import MuxSbVideo from '$lib/storyblok/blocks/muxSbVideo.svelte';
import Image from '$lib/storyblok/blocks/imageBlock.svelte';
import BenefitImageWithText from '$lib/storyblok/blocks/benefitImageWithText.svelte';
import HeroNavigation from '$lib/storyblok/blocks/homepage/heroNavigation.svelte';
import NavItem from '$lib/storyblok/blocks/homepage/navItem.svelte';
import NavButton from '$lib/storyblok/blocks/homepage/navButton.svelte';
import HowItWorksGallery from '$lib/storyblok/blocks/howItWorksGallery.svelte';
import HowItWorksGalleryItem from '$lib/storyblok/blocks/howItWorksGalleryItem.svelte';
import FoodGroundsGalleryItem from '$lib/storyblok/blocks/homepage/foodGroundsGalleryItem.svelte';
import FoodGrounds from '$lib/storyblok/blocks/homepage/foodGrounds.svelte';
import QuoteCarousel from '$lib/storyblok/blocks/homepage/quoteCarousel.svelte';
import QuoteCarouselItem from '$lib/storyblok/blocks/homepage/quoteCarouselItem.svelte';
import Collage from '$lib/storyblok/blocks/homepage/collage.svelte';
import CtaSectionLarge from '$lib/storyblok/blocks/homepage/ctaSectionLarge.svelte';
import Testimonials from '$lib/storyblok/blocks/homepage/testimonials.svelte';
import EppoVariant from '$lib/storyblok/blocks/eppoVariant.svelte';
import LatestStories from '$lib/storyblok/blocks/homepage/latestStories.svelte';
import CustomerReviews from '$lib/storyblok/blocks/homepage/customerReviews.svelte';
import CtaSection from '$lib/storyblok/blocks/homepage/ctaSection.svelte';
import HeroModuleImageContent from '$lib/storyblok/blocks/heroModuleImageContent.svelte';
import wallOfLoveComponents from '$lib/storyblok/wallOfLoveComponents';
import CartValueProps from '$lib/storyblok/blocks/cartValueProps.svelte';
import PageFilter from '$lib/storyblok/blocks/pageFilter.svelte';
import ResponsiveMuxVideo from '$lib/storyblok/blocks/responsiveMuxVideo.svelte';
import { registerComponents } from '$lib/storyblok/sdk';
import TolstoyVideo from '$lib/storyblok/blocks/tolstoyVideo.svelte';
import FullbleedGallery from '$lib/storyblok/blocks/fullbleedGallery.svelte';
import HeroFullbleed from '$lib/storyblok/blocks/heroFullbleed.svelte';
import HeroFloatingVideo from '$lib/storyblok/blocks/heroFloatingVideo.svelte';
import HeroSideBySide from '$lib/storyblok/blocks/heroSideBySide.svelte';
import HeroSideBySideStacked from '$lib/storyblok/blocks/heroSideBySideStacked.svelte';
import HeroPressBanner from '$lib/storyblok/blocks/heroPressBanner.svelte';
import HeroPressBannerItem from '$lib/storyblok/blocks/heroPressBannerItem.svelte';
import ButtonHeroPrimary from '$lib/storyblok/blocks/buttonHeroPrimary.svelte';
import ButtonHeroSecondary from '$lib/storyblok/blocks/buttonHeroSecondary.svelte';
import ButtonV3 from '$lib/storyblok/blocks/buttonV3.svelte';
import Page from '$lib/storyblok/pages/page.svelte';
import CustomPaymentMessagingElement from '$lib/storyblok/blocks/customPaymentMessagingElement.svelte';
import HowItWorksSimple from '$lib/storyblok/blocks/howItWorksSimple.svelte';
import HowItWorksSimpleItem from '$lib/storyblok/blocks/howItWorksSimpleItem.svelte';
import AddToCartButton from '$lib/storyblok/blocks/cart/addToCartButton.svelte';
import InlineProductSelector from '$lib/storyblok/blocks/cart/inlineProductSelector.svelte';
import NavTeaserCard from '$lib/storyblok/blocks/navigation/navTeaserCard.svelte';
import NavMenuBarLink from '$lib/storyblok/blocks/navigation/navMenuBarLink.svelte';
import NavLinkStandard from '$lib/storyblok/blocks/navigation/navLinkStandard.svelte';
import NavLinkHighlight from '$lib/storyblok/blocks/navigation/navLinkHighlight.svelte';
import NavigationExpand from '$lib/storyblok/blocks/navigation/navigationExpand.svelte';
import AssetBlock from '$lib/storyblok/blocks/assetBlock.svelte';
import SimpleImageBlock from '$lib/storyblok/blocks/simpleImageBlock.svelte';
import CartConfiguration from '$lib/storyblok/blocks/cart/cartConfiguration.svelte';
import FeatureContainer from '$lib/storyblok/blocks/featureContainer.svelte';
import CompetitorTable from '$lib/storyblok/blocks/competitorTable.svelte';
import OnlyLogoBanner from '$lib/storyblok/blocks/onlyLogoBanner.svelte';
import ContentSection from '$lib/storyblok/blocks/contentSection.svelte';
import PageSpacer from '$lib/storyblok/blocks/pageSpacer.svelte';
import ValueProp from '$lib/storyblok/blocks/valueProp.svelte';
import HeroHeadlineRotation from '$lib/storyblok/blocks/heroHeadlineRotation.svelte';
import GenericText from '$lib/storyblok/blocks/genericText.svelte';
import TypeformEmbed from '$lib/storyblok/blocks/typeformEmbed.svelte';
import PageGrid16 from '$lib/storyblok/blocks/pageGrid16Block.svelte';
import AccordionGallery from '$lib/storyblok/blocks/boats/accordionGallery.svelte';
import AccordionGalleryCard from '$lib/storyblok/blocks/boats/accordionGalleryCard.svelte';
import FullbleedAsset from '$lib/storyblok/blocks/fullbleedAsset.svelte';
import DynamicStats from '$lib/storyblok/blocks/dynamicStats.svelte';
import ImageCtaBanner from '$lib/storyblok/blocks/imageCtaBanner.svelte';

registerComponents({
	...wallOfLoveComponents,
	page: Page,
	hero_module: HeroModule,
	hero_headline_rotation: HeroHeadlineRotation,
	hero_module_v2: HeroModuleV2,
	hero_module_image_content: HeroModuleImageContent,
	hero_module_nyc: HeroModuleNyc,
	mux_video: MuxSbVideo,
	responsive_mux_video: ResponsiveMuxVideo,
	image: Image,
	button_v3: ButtonV3,
	benefit_image_with_text: BenefitImageWithText,
	homepage_hero_navigation: HeroNavigation,
	homepage_floating_navigation: import('$lib/storyblok/blocks/homepage/floatingNavigation.svelte'),
	homepage_nav_item: NavItem,
	homepage_nav_button: NavButton,
	how_it_works_gallery: HowItWorksGallery,
	how_it_works_gallery_item: HowItWorksGalleryItem,
	homepage_food_grounds: FoodGrounds,
	homepage_food_grounds_gallery_item: FoodGroundsGalleryItem,
	quote_carousel: QuoteCarousel,
	quote_carousel_item: QuoteCarouselItem,
	collage: Collage,
	cta_section: CtaSection,
	cta_section_large: CtaSectionLarge,
	homepage_testimonials: Testimonials,
	cart_addon: import('$lib/storyblok/blocks/cart/cartAddon.svelte'),
	cart_product_addon: import('$lib/storyblok/blocks/cart/cartProductAddon.svelte'),
	cart_value_props: CartValueProps,
	eppo_variant: EppoVariant,
	homepage_latest_stories: LatestStories,
	customer_reviews: CustomerReviews,
	newsletter_banner: import('$lib/storyblok/blocks/newsletterBanner.svelte'),
	link_collection: import('$lib/storyblok/blocks/footer/linkCollection.svelte'),
	cta_banner: import('$lib/storyblok/blocks/ctaBanner.svelte'),
	value_prop_grid: import('$lib/storyblok/blocks/valuePropGrid.svelte'),
	accordion_gallery: AccordionGallery,
	accordion_gallery_card: AccordionGalleryCard,
	page_filter: PageFilter,
	tolstoy_video: TolstoyVideo,
	fullbleed_gallery: FullbleedGallery,
	hero_fullbleed: HeroFullbleed,
	hero_floating_video: HeroFloatingVideo,
	hero_side_by_side: HeroSideBySide,
	hero_side_by_side_stacked: HeroSideBySideStacked,
	hero_press_banner: HeroPressBanner,
	press_banner_item: HeroPressBannerItem,
	hero_primary_button: ButtonHeroPrimary,
	hero_secondary_button: ButtonHeroSecondary,
	custom_payment_messaging_element: CustomPaymentMessagingElement,
	how_it_works_simple: HowItWorksSimple,
	how_it_works_simple_item: HowItWorksSimpleItem,
	product_details: import('$lib/storyblok/blocks/cart/productDetails.svelte'),
	product_checklist_item_collection: import(
		'$lib/storyblok/blocks/cart/productChecklistItemCollection.svelte'
	),
	cart_configuration: CartConfiguration,
	add_to_cart_button: AddToCartButton,
	inline_product_selector: InlineProductSelector,
	nav_teaser_card: NavTeaserCard,
	navigation_expand: NavigationExpand,
	nav_link_highlight: NavLinkHighlight,
	nav_link_standard: NavLinkStandard,
	nav_menu_bar_link: NavMenuBarLink,
	asset: AssetBlock,
	simple_image: SimpleImageBlock,
	feature_container: FeatureContainer,
	competitor_table: CompetitorTable,
	feature_image_gallery: import('$lib/storyblok/blocks/featureImageGallery.svelte'),
	feature_image_gallery_item: import('$lib/storyblok/blocks/featureImageGalleryItem.svelte'),
	fullbleed_asset: FullbleedAsset,
	only_logo_banner: OnlyLogoBanner,
	content_section: ContentSection,
	page_spacer: PageSpacer,
	general_impact: import('$lib/storyblok/blocks/localOffer/generalImpact.svelte'),
	product_banner: import('$lib/storyblok/blocks/productBanner.svelte'),
	value_prop: ValueProp,
	typeform_embed: TypeformEmbed,
	generic_text: GenericText,
	page_grid_16: PageGrid16,
	dynamic_stats: DynamicStats,
	image_cta_banner: ImageCtaBanner,
});
